import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from 'app/components/layouts/MainLayout';
import DashboardPageRoute from './DashboardPageRoute';

export default (
  <Route exact path="/v2/">
    <MainLayout>
      <DashboardPageRoute />
    </MainLayout>
  </Route>
);
